import { useEffect } from "react";
import { Link } from "react-router-dom";
import Breadcrumb from "@/components/feature/Breadcrumb";
import { categories } from "@/mocks/news";

const siteUrl = "https://budingmh.com.cn";

const pillars = [
  { icon: "ri-eye-line", title: "时效优先", text: "刚刚发生的重要事件第一时间呈现，重要进展以快讯流滚动跟进，让读者始终站在信息最前沿。" },
  { icon: "ri-shield-check-line", title: "来源先行", text: "坚持以可核实的来源为报道基础，标注进展状态与不确定性，不夸大、不臆断、不贩卖焦虑。" },
  { icon: "ri-heart-line", title: "尊重隐私", text: "报道力求克制而有温度，对涉及个人的信息审慎处理，尊重当事人隐私与基本权利。" },
  { icon: "ri-refresh-line", title: "及时更正", text: "如报道出现事实出入，会在正文标注更正与进展说明，第一时间同步修正，向读者负责。" },
];

const readers = [
  { name: "阿凯 · 互联网从业者", text: "午休刷一眼首页快讯就能跟上今天发生了什么，栏目清晰，标题实在，是我每天通勤的必备。" },
  { name: "晓雯 · 大学生", text: "娱乐和科技的爆料更新很快，很多话题都是在这里先看到的，点进去读也不冗长，很舒服。" },
  { name: "老周 · 退休编辑", text: "做内容的人能看出编辑在求核实、讲分寸，这一点在快讯类网站里很难得，希望一直保持。" },
];

export default function AboutPage() {
  useEffect(() => {
    document.title = "关于每日爆料_品牌介绍与内容理念";
    const desc = document.querySelector('meta[name="description"]');
    if (desc) {
      desc.setAttribute(
        "content",
        "了解每日爆料：一个聚焦娱乐、社会、财经等领域的即时快讯资讯门户，坚持时效优先、来源先行、尊重隐私与及时更正，欢迎了解我们的理念并联系合作。"
      );
    }
  }, []);

  const jsonLd = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        name: "每日爆料",
        url: siteUrl,
        description: "聚焦娱乐、社会、财经、科技、体育等领域的中文即时快讯资讯门户。",
        email: "baoliao@meiribaoliao.cn",
      },
      {
        "@type": "AboutPage",
        name: "关于每日爆料",
        url: `${siteUrl}/about`,
        description: "每日爆料的品牌介绍、网站定位、发展理念、内容原则与联系方式。",
        about: { "@type": "Organization", name: "每日爆料" },
      },
    ],
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />
      {/* 页头 */}
      <div className="bg-foreground-950 text-background-50">
        <div className="mx-auto max-w-7xl px-4 md:px-6 pt-8 pb-10 md:pb-12">
          <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "关于我们" }]} />
          <div className="mt-6 max-w-3xl">
            <span className="inline-flex items-center gap-1.5 text-accent-400 text-sm"><i className="ri-flag-line"></i>About MeiriBaoliao</span>
            <h1 className="mt-3 font-heading text-3xl md:text-5xl font-black leading-tight">关于每日爆料</h1>
            <p className="mt-4 text-base md:text-lg text-background-200/90 leading-relaxed">
              每日爆料是一个以即时快讯为核心的中文资讯门户。我们相信，在这个信息过载的时代，好的资讯不是越多越好，而是更快、更准、更可信地到达需要它的人。
            </p>
          </div>

          {/* 数据条 */}
          <div className="mt-9 grid grid-cols-2 md:grid-cols-4 gap-4">
            {[
              { num: "5", label: "精品栏目" },
              { num: "24h", label: "滚动更新" },
              { num: "1000+", label: "条已刊爆料" },
              { num: "50w+", label: "周活跃读者" },
            ].map((s, i) => (
              <div key={i} className="bg-background-100/10 border border-background-100/15 rounded-lg px-5 py-4">
                <div className="font-heading text-2xl md:text-3xl font-black text-accent-400">{s.num}</div>
                <div className="mt-1 text-xs text-background-200/70">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="mx-auto max-w-7xl px-4 md:px-6 py-10 md:py-14 space-y-14">
        {/* 品牌介绍 */}
        <section id="about-us">
          <div className="flex items-center gap-3 mb-6">
            <span className="w-1.5 h-6 rounded-full bg-primary-500 inline-block"></span>
            <h2 className="font-heading text-xl md:text-2xl font-black text-foreground-950">品牌介绍与网站定位</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="space-y-4 text-foreground-700 leading-[1.9]">
              <p>
                每日爆料创立的初衷，是希望用一套清晰、克制、可持续的方式，把分散在娱乐、社会、财经、科技、体育等领域的每日最新动态，整理成真正值得读的资讯。我们不做流量的搬运工，而是做信息的梳理者与核实者。
              </p>
              <p>
                在内容上，我们覆盖从重磅猛料到行业观察、从热点事件到生活方式等多个维度；在表达上，我们追求标题准确、正文克制、结构清爽，既让快节奏的读者能几秒把握要点，也让愿意深读的读者有内容可读。
              </p>
            </div>
            <div className="bg-background-100 border border-background-200 rounded-xl p-6 space-y-4">
              <h3 className="font-heading font-bold text-foreground-950">我们服务的人群</h3>
              <ul className="space-y-3 text-foreground-700 text-sm leading-relaxed">
                <li className="flex gap-3"><span className="w-7 h-7 flex items-center justify-center rounded-full bg-primary-100 text-primary-700 flex-shrink-0"><i className="ri-briefcase-line text-sm"></i></span>通勤途中快速跟上热点的上班族</li>
                <li className="flex gap-3"><span className="w-7 h-7 flex items-center justify-center rounded-full bg-accent-100 text-accent-700 flex-shrink-0"><i className="ri-graduation-cap-line text-sm"></i></span>关注娱乐、科技与生活趋势的年轻读者</li>
                <li className="flex gap-3"><span className="w-7 h-7 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-800 flex-shrink-0"><i className="ri-line-chart-line text-sm"></i></span>关注财经与产业动态的理性观察者</li>
                <li className="flex gap-3"><span className="w-7 h-7 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 flex-shrink-0"><i className="ri-shield-star-line text-sm"></i></span>愿意提供线索、共同还原真相的爆料者</li>
              </ul>
            </div>
          </div>
        </section>

        {/* 理念 */}
        <section id="principle" className="bg-background-100/70 border border-background-200 rounded-2xl p-6 md:p-9">
          <div className="flex items-center gap-3 mb-6">
            <span className="w-1.5 h-6 rounded-full bg-accent-500 inline-block"></span>
            <h2 className="font-heading text-xl md:text-2xl font-black text-foreground-950">发展理念与内容原则</h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {pillars.map((p) => (
              <div key={p.title} className="bg-background-50 border border-background-200 rounded-xl p-5">
                <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-600 text-background-50 text-xl"><i className={p.icon}></i></span>
                <h3 className="mt-3 font-heading font-bold text-foreground-950">{p.title}</h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{p.text}</p>
              </div>
            ))}
          </div>
        </section>

        {/* 读者口碑 */}
        <section>
          <div className="flex items-center gap-3 mb-6">
            <span className="w-1.5 h-6 rounded-full bg-secondary-500 inline-block"></span>
            <h2 className="font-heading text-xl md:text-2xl font-black text-foreground-950">读者怎么说</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {readers.map((r) => (
              <figure key={r.name} className="bg-background-100 border border-background-200 rounded-xl p-6">
                <i className="ri-double-quotes-l text-primary-300 text-3xl"></i>
                <blockquote className="mt-3 text-foreground-700 leading-relaxed text-sm">{r.text}</blockquote>
                <figcaption className="mt-4 flex items-center gap-3">
                  <span className="w-10 h-10 rounded-full bg-primary-100 text-primary-700 flex items-center justify-center font-bold">{r.name.slice(0, 1)}</span>
                  <span className="text-sm font-medium text-foreground-800">{r.name}</span>
                </figcaption>
              </figure>
            ))}
          </div>
        </section>

        {/* 联系方式 */}
        <section id="contact" className="bg-gradient-to-r from-primary-700 to-primary-600 rounded-2xl px-6 md:px-10 py-10">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
            <div>
              <h2 className="font-heading text-2xl md:text-3xl font-black text-background-50">联系我们</h2>
              <p className="mt-3 text-background-100/90 leading-relaxed">
                无论你是想提供新鲜爆料、洽谈商务合作，还是对我们的内容有建议，都非常欢迎与我们联系。我们会在工作时间内尽快回复每一条来信。
              </p>
            </div>
            <div className="space-y-4">
              <div className="bg-background-50/10 border border-background-50/15 rounded-xl p-5 flex items-center gap-4">
                <span className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-500 text-foreground-950 text-2xl flex-shrink-0"><i className="ri-mail-send-line"></i></span>
                <div>
                  <div className="text-xs text-background-200/70">爆料 / 商务合作邮箱</div>
                  <a href="mailto:baoliao@meiribaoliao.cn" className="text-lg font-medium text-background-50 hover:text-accent-200 transition-colors">baoliao@meiribaoliao.cn</a>
                </div>
              </div>
              <div className="bg-background-50/10 border border-background-50/15 rounded-xl p-5 flex items-center gap-4">
                <span className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-500 text-foreground-950 text-2xl flex-shrink-0"><i className="ri-time-line"></i></span>
                <div>
                  <div className="text-xs text-background-200/70">工作时间</div>
                  <div className="text-background-50 font-medium">周一至周五 9:00 - 18:00</div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 去浏览 */}
        <section className="text-center">
          <p className="text-foreground-600 text-sm mb-4">新鲜猛料，持续更新中</p>
          <div className="flex items-center justify-center gap-2 flex-wrap">
            {categories.map((c) => (
              <Link key={c.slug} to={`/category/${c.slug}`} className="inline-flex items-center gap-1.5 bg-background-50 border border-background-200 text-foreground-700 text-sm px-4 py-2 rounded-full hover:border-primary-400 hover:text-primary-700 transition-colors whitespace-nowrap">
                <i className="ri-price-tag-3-line"></i>{c.name}爆料
              </Link>
            ))}
            <Link to="/" className="inline-flex items-center gap-1.5 bg-primary-600 text-background-50 text-sm px-5 py-2 rounded-full hover:bg-primary-500 transition-colors whitespace-nowrap">
              <i className="ri-home-5-line"></i>返回首页
            </Link>
          </div>
        </section>
      </div>
    </>
  );
}